var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scroll-animate",
      rawName: "v-scroll-animate"
    }],
    staticClass: "offer-feature-section",
    attrs: {
      "id": "processes"
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, _vm._l(_vm.fields.field_one.value.boxes, function (feature, index) {
    return _c('feature3', {
      key: feature.name,
      ref: "features",
      refInFor: true,
      attrs: {
        "feature": feature
      },
      on: {
        "open": function ($event) {
          return _vm.onOpen(index);
        }
      }
    });
  }), 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }